import { useQuery } from "@tanstack/react-query";
import api from "./api";
import { useLang } from "./i18n";

export function useConfig() {
  const { lang } = useLang();
  return useQuery({
    queryKey: ["config", lang],
    queryFn: async () => (await api.get("/config", { params: { lang } })).data,
    staleTime: 1000 * 60 * 30,
  });
}
